import type { CatalogMessageId } from '~/i18n';

/** The views the patient list can open on, as the connector names them, each with its tab's name. */
export const STARTUP_VIEW_LABELS = {
    MyTasks: 'patientList.view.tasks',
    AllPatients: 'patientList.view.all',
} as const satisfies Record<string, CatalogMessageId>;

export type StartupView = keyof typeof STARTUP_VIEW_LABELS;

/** The views in the order they are offered. */
export const STARTUP_VIEWS: readonly StartupView[] = ['MyTasks', 'AllPatients'];

/** The view a user who never chose one opens on; the connector defaults to it too. */
const DEFAULT_STARTUP_VIEW: StartupView = 'AllPatients';

/** The stored startup view, or the default when none is stored or it is not one of the views. */
export function resolveStartupView(
    stored: string | null | undefined
): StartupView {
    return (
        STARTUP_VIEWS.find((view) => view === stored) ?? DEFAULT_STARTUP_VIEW
    );
}
